/* tslint:disable */
/* eslint-disable */
/**
 * Hyper-Timesheet.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GiustificativiUploadAllegatiDTO } from './GiustificativiUploadAllegatiDTO';
import {
    GiustificativiUploadAllegatiDTOFromJSON,
    GiustificativiUploadAllegatiDTOFromJSONTyped,
    GiustificativiUploadAllegatiDTOToJSON,
    GiustificativiUploadAllegatiDTOToJSONTyped,
} from './GiustificativiUploadAllegatiDTO';

/**
 * 
 * @export
 * @interface GiustificativiUploadArchivioDTO
 */
export interface GiustificativiUploadArchivioDTO {
    /**
     * 
     * @type {Array<GiustificativiUploadAllegatiDTO>}
     * @memberof GiustificativiUploadArchivioDTO
     */
    rimborsi?: Array<GiustificativiUploadAllegatiDTO> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof GiustificativiUploadArchivioDTO
     */
    idsArchivio?: Array<number> | null;
}

/**
 * Check if a given object implements the GiustificativiUploadArchivioDTO interface.
 */
export function instanceOfGiustificativiUploadArchivioDTO(value: object): value is GiustificativiUploadArchivioDTO {
    return true;
}

export function GiustificativiUploadArchivioDTOFromJSON(json: any): GiustificativiUploadArchivioDTO {
    return GiustificativiUploadArchivioDTOFromJSONTyped(json, false);
}

export function GiustificativiUploadArchivioDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): GiustificativiUploadArchivioDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'rimborsi': json['rimborsi'] == null ? undefined : ((json['rimborsi'] as Array<any>).map(GiustificativiUploadAllegatiDTOFromJSON)),
        'idsArchivio': json['idsArchivio'] == null ? undefined : json['idsArchivio'],
    };
}

export function GiustificativiUploadArchivioDTOToJSON(json: any): GiustificativiUploadArchivioDTO {
    return GiustificativiUploadArchivioDTOToJSONTyped(json, false);
}

export function GiustificativiUploadArchivioDTOToJSONTyped(value?: GiustificativiUploadArchivioDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'rimborsi': value['rimborsi'] == null ? undefined : ((value['rimborsi'] as Array<any>).map(GiustificativiUploadAllegatiDTOToJSON)),
        'idsArchivio': value['idsArchivio'],
    };
}

